import React from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../components/shared";
import { CheckoutFooter } from "../components/checkout";
import { useTranslation } from "../hooks/useTranslation";
import "../styles/underConstruction/UnderConstruction.css";

const UnderConstruction = () => {
  const navigate = useNavigate();
  const { t, getLocalizedPath } = useTranslation('underConstruction');

  const handleExploreCatalog = () => {
    navigate(getLocalizedPath('/catalog'));
  };

  const handleContactUs = () => {
    navigate(getLocalizedPath('/contact'));
  };

  const handleBackHome = () => {
    navigate(getLocalizedPath('/'));
  };

  return (
    <div className="under-construction-page">
      <div className="under-construction-container">
        <Header />
        
        <main className="under-construction-main">
          <div className="construction-hero">
            <div className="construction-hero-container">
              
              {/* Construction Icon */}
              <div className="construction-icon">
                <svg
                  width="120"
                  height="120"
                  viewBox="0 0 120 120"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="60" cy="60" r="60" fill="rgba(0, 155, 49, 0.1)"/>
                  <path
                    d="M45 35L75 35C76.6569 35 78 36.3431 78 38V42C78 43.6569 76.6569 45 75 45H45C43.3431 45 42 43.6569 42 42V38C42 36.3431 43.3431 35 45 35Z"
                    fill="#009B31"
                  />
                  <path
                    d="M35 50H85C86.6569 50 88 51.3431 88 53V77C88 78.6569 86.6569 80 85 80H35C33.3431 80 32 78.6569 32 77V53C32 51.3431 33.3431 50 35 50Z"
                    fill="#009B31"
                    opacity="0.7"
                  />
                  <path
                    d="M50 60H70M50 67H70M42 60H45M42 67H45"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <circle cx="60" cy="28" r="3" fill="#009B31"/>
                  <path
                    d="M57 25L63 25M57 31L63 31"
                    stroke="#009B31"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </div>

              {/* Main Content */}
              <div className="construction-content">
                <h1 className="construction-title">
                  {t('hero.title')}
                </h1>

                <p className="construction-subtitle">
                  {t('hero.subtitle')}
                </p>

                <div className="construction-progress">
                  <div className="progress-bar">
                    <div className="progress-fill"></div>
                  </div>
                  <p className="progress-text">{t('hero.progress')}</p>
                </div>

                {/* Action Buttons */}
                <div className="construction-actions">
                  <button 
                    className="action-btn primary"
                    onClick={handleExploreCatalog}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.5 7.5L15 5H5L2.5 7.5V15C2.5 15.6904 3.05964 16.25 3.75 16.25H16.25C16.9404 16.25 17.5 15.6904 17.5 15V7.5Z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2.5 7.5H17.5"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12.5 11.25C12.5 12.2165 11.7165 13 10.75 13H9.25C8.2835 13 7.5 12.2165 7.5 11.25"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {t('actions.explore')}
                  </button>

                  <button
                    className="action-btn secondary"
                    onClick={handleContactUs}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.75 14.1667V16.6667C18.7511 16.9022 18.7030 17.1356 18.6084 17.3512C18.5139 17.5668 18.3749 17.7598 18.2000 17.9177C18.0251 18.0755 17.8180 18.1946 17.5922 18.2674C17.3664 18.3403 17.1269 18.3654 16.8917 18.3417C14.1583 18.0583 11.5417 17.0917 9.30833 15.5417C7.23319 14.1337 5.53681 12.2373 4.375 10C2.79167 7.74167 1.80833 5.09167 1.54167 2.325C1.51806 2.09206 1.54308 1.85503 1.61472 1.63162C1.68635 1.40821 1.80378 1.20299 1.95929 1.02947C2.1148 0.855958 2.30532 0.717886 2.51849 0.624253C2.73167 0.530621 2.96243 0.483299 3.19583 0.483333H5.69583C6.07398 0.479718 6.44186 0.610131 6.73451 0.850712C7.02716 1.09129 7.22577 1.42547 7.29583 1.79583C7.42698 2.53624 7.64865 3.25926 7.95833 3.95L7.15833 4.75C8.41162 6.94152 10.3585 8.88838 12.55 10.1417L13.35 9.34167C14.0408 9.65135 14.7638 9.87302 15.5042 10.0042C15.8745 10.0742 16.2087 10.2728 16.4493 10.5655C16.6899 10.8581 16.8203 11.226 16.8167 11.6042L18.75 14.1667Z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {t('actions.contact')}
                  </button>

                  <button
                    className="action-btn tertiary"
                    onClick={handleBackHome}
                  >
                    {t('actions.backHome')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </main>
        
        <CheckoutFooter />
      </div>
    </div>
  );
};

export default UnderConstruction;